// Do not edit manually

export const IMAGES = {
  CAMERETTA_JOB_1: "/images/uno_per_tutti_2025-114.jpg",
  CAMERETTA_JOB_10: "/images/uno_per_tutti_2025-102.jpg",
  CAMERETTA_JOB_11: "/images/uno_per_tutti_2025-101.jpg",
  CAMERETTA_JOB_12: "/images/uno_per_tutti_2025-98.jpg",
  CAMERETTA_JOB_13: "/images/uno_per_tutti_2025-100.jpg",
  CAMERETTA_JOB_14: "/images/uno_per_tutti_2025-99.jpg",
  CAMERETTA_JOB_15: "/images/uno_per_tutti_2025-96.jpg",
  CAMERETTA_JOB_16: "/images/uno_per_tutti_2025-95.jpg",
  CAMERETTA_JOB_17: "/images/uno_per_tutti_2025-93.jpg",
  CAMERETTA_JOB_18: "/images/uno_per_tutti_2025-94.jpg",
  CAMERETTA_JOB_19: "/images/uno_per_tutti_2025-92.jpg",
  CAMERETTA_JOB_2: "/images/uno_per_tutti_2025-113.jpg",
  CAMERETTA_JOB_20: "/images/uno_per_tutti_2025-72.jpg",
  CAMERETTA_JOB_21: "/images/uno_per_tutti_2025-73.jpg",
  CAMERETTA_JOB_22: "/images/uno_per_tutti_2025-67.jpg",
  CAMERETTA_JOB_23: "/images/uno_per_tutti_2025-66.jpg",
  CAMERETTA_JOB_24: "/images/uno_per_tutti_2025-65.jpg",
  CAMERETTA_JOB_25: "/images/uno_per_tutti_2025-64.jpg",
  CAMERETTA_JOB_26: "/images/uno_per_tutti_2025-63.jpg",
  CAMERETTA_JOB_27: "/images/uno_per_tutti_2025-62.jpg",
  CAMERETTA_JOB_28: "/images/uno_per_tutti_2025-61.jpg",
  CAMERETTA_JOB_29: "/images/uno_per_tutti_2025-58.jpg",
  CAMERETTA_JOB_3: "/images/uno_per_tutti_2025-115.jpg",
  CAMERETTA_JOB_30: "/images/uno_per_tutti_2025-59.jpg",
  CAMERETTA_JOB_4: "/images/uno_per_tutti_2025-109.jpg",
  CAMERETTA_JOB_5: "/images/uno_per_tutti_2025-112.jpg",
  CAMERETTA_JOB_6: "/images/uno_per_tutti_2025-107.jpg",
  CAMERETTA_JOB_7: "/images/uno_per_tutti_2025-108.jpg",
  CAMERETTA_JOB_8: "/images/uno_per_tutti_2025-106.jpg",
  CAMERETTA_JOB_9: "/images/uno_per_tutti_2025-105.jpg",
  LOGO_GIESSEGI: "/images/logo.png",
  LOGO_MOBILANDIA: "/images/Logo Mobilandia contorno bianco.png",
} as const;

export type ImageKey = keyof typeof IMAGES;
